import { t } from 'i18next';

import { DISPATCH_METHODS } from '~constants/address';
import { EXTERNAL_DELIVERY_COMPANIES } from '~constants/delivery';
import { PAYMENT_METHODS, PAYMENT_METHODS_SERVER } from '~constants/paymentMethods';
import { someGiftCard } from '~models/shoppingCart';
import { COUNTRIES, CURRENT_COUNTRY_ID } from '~constants/environment';

import { getExternalDeliveryCashMax } from './constants';

export const giftCardValidation = items =>
  someGiftCard(items) && t('PaymentMethodDisabled:giftCardOnlinePayments');

export const disabledPaymentMethod = cartItems =>
  Object.fromEntries(
    [PAYMENT_METHODS.cash, PAYMENT_METHODS.sodexo, PAYMENT_METHODS_SERVER.credit].map(paymentMethod => [
      paymentMethod,
      () => giftCardValidation(cartItems)
    ])
  );

const isDelivery = dispatchType => dispatchType === DISPATCH_METHODS.PJ_DELIVERY;

const renderCardPaymentMethod = ({ dispatchType, currentSubsidiary }) => {
  const { externalDelivery, externalDeliveryCompany } = currentSubsidiary;
  return !(
    isDelivery(dispatchType) &&
    externalDelivery &&
    [EXTERNAL_DELIVERY_COMPANIES.DEELIVERS, EXTERNAL_DELIVERY_COMPANIES.PEDIDOS_YA].includes(
      externalDeliveryCompany
    )
  );
};

export const renderCashPaymentMethod = ({ dispatchType, currentSubsidiary }, shoppingCart) => {
  const { externalDelivery, externalDeliveryCompany } = currentSubsidiary;
  return !(
    isDelivery(dispatchType) &&
    externalDelivery &&
    [EXTERNAL_DELIVERY_COMPANIES.PEDIDOS_YA].includes(externalDeliveryCompany) &&
    [COUNTRIES.cl].includes(CURRENT_COUNTRY_ID) &&
    shoppingCart?.total > getExternalDeliveryCashMax(externalDeliveryCompany)
  );
};

const renderPaymentMethods = (searchStore, shoppingCart) => ({
  [PAYMENT_METHODS_SERVER.credit]: () => renderCardPaymentMethod(searchStore),
  [PAYMENT_METHODS.card]: () => renderCardPaymentMethod(searchStore),
  [PAYMENT_METHODS_SERVER.cash]: () => renderCashPaymentMethod(searchStore, shoppingCart)
});

export const renderPaymentMethod = (paymentMethodKey, searchStore, shoppingCart) => {
  const renderPaymentMethodFn = renderPaymentMethods(searchStore, shoppingCart)[paymentMethodKey];
  return !renderPaymentMethodFn || renderPaymentMethodFn();
};
